var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-layout',{staticClass:"buttonContainer",attrs:{"md-flex":"100"}},[_c('md-layout',[_c('md-button',{on:{"click":_vm.back}},[_c('md-icon',[_vm._v("keyboard_return")]),_vm._v(" "),_c('span',[_vm._v("Return")])],1),_vm._v(" "),_vm._t("centreLeft")],2),_vm._v(" "),_c('md-layout',{staticClass:"right"},[_vm._t("centreRight"),_vm._v(" "),_vm._t("right")],2),_vm._v(" "),_c('div',{staticClass:"border"},[_c('hr')])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73b050f1","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/util/ActionButtons.vue
// module id = 847
// module chunks = 0